export enum analyticsEvents {
  REGISTER_USER = "REGISTER_USER",
  LOGIN_USER = "LOGIN_USER",
  CREATE_CV = "CREATE_CV",
  NEW_PUBLISH_CV = "NEW_PUBLISH_CV",
}
